import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
     // March 24, 2026 Customer requesets wholesale customers not use the AJAX cart or cart drawer but rather go stratight to cart
     if (window.isWholesaleCustomer) {
        window.location.href = '/cart';
        return;
      }

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
 // March 24, 2026 Customer requesets wholesale customers not use the AJAX cart or cart drawer but rather go stratight to cart
    if (window.isWholesaleCustomer) {
    window.location.href = '/cart';
    return;
  }
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
